import React, { Component } from 'react';
import { Modal, Button, Row, Col } from 'react-bootstrap'
import { withRouter } from 'react-router-dom';

class LoginOrQuote extends Component {
    state = {}
    redirect=()=>{
        this.props.close()
        this.props.history.push('/login');  
    }
    render() {
        return (
            <div  className="bl-modal" onClick={this.props.close}>
                <div style={this.props.width && { width: this.props.width }} className="bl-modal-content" onClick={e => e.stopPropagation()}>
                    <div className={(this.props.darkmode ? "darkmode-card-header" : "lightmode-card-header") + " bl-modal-body"} style={{ textAlign: "center", margin: "auto" }}>
 
                                <Button onClick={this.props.close} style={{height: "100px", margin: "20px"}}>
                                    Get A Free Quote Now

                                </Button>
                                <h4>
                                    OR
                                </h4>
                        
                                <Button onClick={()=>this.redirect()} style={{height: "100px", margin: "20px"}}>
                                    Create Account Or Login
                                </Button>

                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(LoginOrQuote);


